/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import OutlineButton from '../../MUICustomButton/OutlineButton';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_CLIENT_CONTACT_REQUIRED, ERR_CLIENT_NAME_REQUIRED, ERR_EMAIL, ERR_EMAIL_INVALID, UNKNOWN_ERR } from 'src/constants/constant';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled, TextField } from '@mui/material';
import type { EditESPClientFormInputs, RootState } from '../../types/types';
import GradientButton from '../../MUICustomButton/GradientButton';
import SubClientList from './SubClientList';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { getClientDetailsById, updateClientData } from 'src/services/emailAPIClientServices';
import { useNavigate } from 'react-router-dom';
import MUIModal from '../../MUIModal/MUIModal';
import ClientConfigurationMapping from './ClientConfigurationMapping';
import Button from '../../CustomButton/Button';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import moment from 'moment';
import { getESPConnectionData, getESPConnectionDataById } from 'src/services/emailAPIESPServices';
export interface PropsType {
    clientId?: string;
    clientData?: any;
    step?: string;
    onCancel: () => void;
}

const validationSchema = Yup.object().shape({
    clientName: Yup.string().required(ERR_CLIENT_NAME_REQUIRED).matches(/^\S.*$/, "First character should not be a space"),
    clientContact: Yup.string().required(ERR_CLIENT_CONTACT_REQUIRED).matches(/^\S.*$/, "First character should not be a space"),
    // lastName: Yup.string().required(UPDATE_USER_ERROR_LAST_NAME).matches(/^[a-zA-Z0-9\s]*$/, NEW_USER_ERROR_INVALID_LAST_NAME),
    email: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    espConnectionId: Yup.string().required("Please select email service provider"),
    
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


function EditClientForm({ clientId, clientData, step, onCancel }: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false)
    const [selectedClientData, setSelectedClientData] = useState<any>()
    const [showClientConfigurationModal, setShowClientConfigurationModal] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const [formValueUpdated, setFormValueUpdated] = useState<boolean>(false)
    const [openConfirmPopup, setOpenConfirmPopup] = useState<boolean>(false);
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);
    const [showImportMappingModal, setShowImportMappingModal] = useState<boolean>(false);
    const [showExportMappingModal, setShowExportMappingModal] = useState<boolean>(false);

    const [espConnectionData, setESPConnectionData] = useState<any>([])

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<EditESPClientFormInputs>({
        resolver: yupResolver(validationSchema),
    });

    const getClientDetails = (): void => {
        setIsDataLoading(true)
        if (clientId) {
            getClientDetailsById(clientId).then(
                (res: any) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            setSelectedClientData(res.data.data[0])
                            const clientDataArr: any = res.data.data[0]
                            setValue("clientName", clientDataArr.clientName)
                            setValue("clientContact", clientDataArr.clientContact)
                            setValue("email", clientDataArr.email)
                            
                            setValue("espConnectionId", clientDataArr.espConnectionId ? clientDataArr.espConnectionId.toString() : "0")
                            setValue("espDomainName", clientDataArr.espDomainName)

                            getESPConnectionDataById(res.data.data[0].espConnectionId).then(
                                (res1: any) => {
                                    if (res1.status === 200) {
                                        if (res1.data.result === 1) {
                                            const connectionData = res1.data.data[0]
                                            
                                            setValue("domainName", connectionData.domain)
                                            setValue("fromEmailName", connectionData.fromName)
                                            setValue("fromEmailAddress", connectionData.fromEmail)
                                        }
                                    }
                                }
                            )
                            .catch(
                                (error) => console.log(error)
                            )
                        }

                    }
                }
            )
                .catch(
                    error => console.log("Error: ", error)
                )
                .finally(() => {
                    setIsDataLoading(false)
                })
        }

    }

    useEffect(() => {
        getClientDetails()
    }, [clientId, clientData])

    useEffect(() => {
        getESPConnectionData().then(
            (res: any) => {
                if(res.status === 200) {
                    if(res.data.result === 1) {
                        setESPConnectionData(res.data.data)
                    }
                }
            }
        )
        .catch(
            (error) => console.log(error)
        )
    }, [])

    const onSubmit = async (data: EditESPClientFormInputs): Promise<void> => {
        setIsLoading(true)


        const requestParams = {
            "id": clientData.id,
            "clientName": data.clientName,
            "email": data.email,
            "clientContact": data.clientContact,
            "parentId": clientData.parentId,
            "modifiedBy": user?.id,
            "espConnectionId": data.espConnectionId ? data.espConnectionId : 0,
            "espDomainName": data.espDomainName
        }

        try {
            //@ts-ignore
            const res = await updateClientData(requestParams);
            
            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success("Client updated successfully");

                    setTimeout(() => {
                        onCancel()
                    }, 1000)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                    NotificationManager.error(errorMsg.includes('Client name already exists') ? 'Client name already exists' : UNKNOWN_ERR, '', 5000);
                }
            }
        } catch (error) {
            console.error("Error occurred:", error);
            NotificationManager.error("Unknown error has occurred");
        } finally {
            setIsLoading(false);
        }
    }

    const handleFormReset = (): void => {
        onCancel()
    }

    const handleClientConfiguration = (): void => {
        setShowClientConfigurationModal(true)
    }

    const handleConfirmClose = (): void => {
        setOpenConfirmPopup(false)
    }
    const handleCloseClientConfiguration = (status: string | null = null): void => {
        if (status === null && formValueUpdated === true) {
            setOpenConfirmPopup(true)
        } else {
            setShowClientConfigurationModal(false)
        }
    }
    const handleFormValueUpdated = (value: boolean): void => {
        setFormValueUpdated(value)
    }
    const handleConfirmOpen = (): void => {
        setShowImportMappingModal(false)
        setShowExportMappingModal(false)
        setShowClientConfigurationModal(false)
        setFormValueUpdated(false)
        setOpenConfirmPopup(false)
    }

    return (
        <>
            <div >
                {
                    isDataLoading ? <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div> :

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                console.log('Form data:', errors);
                                void handleSubmit(onSubmit)(e);
                            }}
                        >
                            {
                                step === "1" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="clientName"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"Client name*"}
                                                                autoComplete="off"
                                                                placeholder={"Client name*"}

                                                                error={Boolean(errors.clientName)}
                                                            />
                                                            {errors.clientName && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.clientName.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="clientContact"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"Client contact*"}
                                                                autoComplete="off"
                                                                placeholder={"Client contact*"}

                                                                error={Boolean(errors.clientContact)}
                                                            />
                                                            {errors.clientContact && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.clientContact.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className="w-full relative ">
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="email"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="Email*"
                                                                autoComplete="off"
                                                                placeholder="Email*"

                                                                error={Boolean(errors.email)}
                                                            />
                                                            {errors.email && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.email.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            {
                                step === "2" &&
                                <React.Fragment>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="espConnectionId"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <Autocomplete
                                                                options={espConnectionData} // The list of clients
                                                                getOptionLabel={(option: any) => option.connectionName} // Use clientName for display
                                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                                //@ts-ignore
                                                                isOptionEqualToValue={(option, value) => option.id === value} // Match by ID
                                                                value={espConnectionData.find((esp: any) => esp.id === field.value)} // Match current value
                                                                onChange={(_, selectedConnection) => {
                                                                    field.onChange(selectedConnection.id); // Update the form state
                                                                    setValue("espDomainName", selectedConnection.domain)
                                                                    setValue("fromEmailName", selectedConnection.fromName)
                                                                    setValue("fromEmailAddress", selectedConnection.fromEmail)
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Email Service Provider*"
                                                                        placeholder="Select Email Service Provider"
                                                                        error={Boolean(errors.espConnectionId)}
                                                                    />
                                                                )}
                                                                disableClearable // Prevent the clear button
                                                            />
                                                            {errors.espConnectionId && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.espConnectionId.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">


                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="espDomainName"
                                                    control={control}
                                                    defaultValue=''
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="Domain Name"
                                                                autoComplete="off"
                                                                placeholder="Domain Name"
                                                                disabled

                                                                error={Boolean(errors.espDomainName)}
                                                            />
                                                            {errors.espDomainName && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.espDomainName.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='grid gap-5 grid-cols-2'>
                                        <div className='w-full relative'>
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="fromEmailName"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label={"From Email Name"}
                                                                autoComplete="off"
                                                                placeholder={"From Email Name"}
                                                                disabled

                                                                error={Boolean(errors.fromEmailName)}
                                                            />
                                                            {errors.fromEmailName && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.fromEmailName.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-full relative ">
                                            <div className="mb-[30px]">
                                                <Controller
                                                    name="fromEmailAddress"
                                                    defaultValue=""
                                                    control={control}
                                                    render={({ field }) => (
                                                        <div>
                                                            <TextField
                                                                {...field}
                                                                fullWidth
                                                                label="From Email Address"
                                                                autoComplete="off"
                                                                placeholder="From Email Address"
                                                                disabled

                                                                error={Boolean(errors.fromEmailAddress)}
                                                            />
                                                            {errors.fromEmailAddress && (
                                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                                    {errors.fromEmailAddress.message}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }

                            <div className='flex gap-2 justify-end'>
                                <OutlineButton color='gray' onClick={() => handleFormReset()} width='130px'>Cancel</OutlineButton>
                                <GradientButton type='submit' color='red' onClick={handleFormReset} width='130px'>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                            </div>

                        </form>
                }
            </div>
            <MUIModal title="Client Configuration" openModal={showClientConfigurationModal} closeModal={handleCloseClientConfiguration} >
                <ClientConfigurationMapping clientId={clientId as unknown as number} clientName={clientData?.clientName} formValueUpdated={handleFormValueUpdated} closeModal={handleCloseClientConfiguration} />
            </MUIModal>
            <BootstrapDialog
                onClose={handleConfirmClose}
                aria-labelledby="customized-dialog-title"
                open={openConfirmPopup}
                PaperProps={{
                    sx: {
                        width: '550px',
                        height: '200px'
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    Review changes
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleConfirmClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                   <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
                </IconButton>
                <DialogContent>
                    <p className='text-14 text-muted'>{`You haven't saved your changes. Are you sure you want to leave the page?`}</p>
                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <Button btntype={"button"} onClick={handleConfirmClose} label={"Cancel"} type={'default'} size={'small'} disabled={isModalSaveLoading}></Button>
                    <Button btntype="submit" label={!isModalSaveLoading ? "Discard" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleConfirmOpen} disabled={isModalSaveLoading}></Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    )
}

export default EditClientForm